import MyInterestsApp from "@/_roots/myInterests/MyInterestsApp.vue";
import VueInstance from "@/main";
import router from "@/_roots/myInterests/router";

VueInstance(MyInterestsApp, router);
